// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnIcon {
  text-align: center;
}

.title {
  text-align: center;
  flex: 1;
}

.form-group {
  margin-bottom: 10px;
}

.participant-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-participant-button {
  color: white;
}

.btn-add-location {
  color: black;
}

.clients {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  flex-direction: row;
  text-align: center;
}

.clientBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex: 0 0 auto;
  height: 3rem;
  width: 3rem;
  border-radius: 80px;
  cursor: pointer;
  color: white;
}

.clientBox p {
  overflow: hidden;
  white-space: nowrap;
}

.participant {
  padding: 1em;
  margin: 5px;
  border-radius: 10px;
  background-color: #f5f5f5;
  margin-bottom: 10px;
}

ion-item {
  --inner-padding-start: 0;
}

ion-content {
  --ion-background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/sessions/form-session/session-form.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,OAAA;AAAF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,wCAAA;AADF","sourcesContent":["\r\n.btnIcon {\r\n  text-align: center;\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  flex: 1;\r\n}\r\n\r\n\r\n.form-group {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.participant-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.add-participant-button {\r\n  color: white;\r\n}\r\n\r\n.btn-add-location {\r\n  color: black;\r\n}\r\n\r\n.clients {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  overflow-x: scroll;\r\n  flex-direction: row;\r\n  text-align: center;\r\n}\r\n\r\n.clientBox {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.5rem;\r\n  flex: 0 0 auto;\r\n  height: 3rem;\r\n  width: 3rem;\r\n  border-radius: 80px;\r\n  cursor: pointer;\r\n  color: white;\r\n}\r\n\r\n.clientBox p {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.participant{\r\n  padding: 1em;\r\n  margin: 5px;\r\n  border-radius: 10px;\r\n  background-color: #f5f5f5;\r\n  margin-bottom: 10px;\r\n}\r\n\r\nion-item {\r\n  --inner-padding-start: 0;\r\n}\r\n\r\nion-content{\r\n  --ion-background-color: white !important; \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
